"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const common_components_1 = require("@zapier/common-components");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const dropdownNavItems_1 = require("../../PrettySelect/dropdownNavItems");
const CustomMapper_1 = __importDefault(require("../../CustomMapper"));
const EmptyCustomMapper_1 = __importDefault(require("../../EmptyCustomMapper"));
const FloatingMenu_1 = __importDefault(require("../../FloatingMenu"));
const OptionsPane_1 = __importDefault(require("./OptionsPane"));
const useLoadInitialOptions_1 = __importDefault(require("./useLoadInitialOptions"));
const common_1 = require("../../common");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        padding: `${theme_1.Spacing.small}px ${theme_1.Spacing.small}px ${theme_1.Spacing.medium}px ${theme_1.Spacing.small}px`,
    },
    paneWrapper: {
        padding: `0px ${theme_1.Spacing.small}px`,
    },
    rootOption: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: 14,
        fontWeight: 600,
        ':hover': {
            color: design_system_1.Colors.blue500,
        },
        ':focus': {
            color: design_system_1.Colors.blue500,
        },
    },
    rootOptionLabel: {
        marginLeft: theme_1.Spacing.small,
    },
});
const DropdownMenu = (props) => {
    const { getItemProps, getMenuProps, highlightedIndex, isLoadingMore, itemsLabel, items, onClear, onLoadOptions, loadMoreState, clearSelection, selectItem, selectedItem, choiceGroups, closeMenu, setHighlightedIndex, canAddSearchStep, onAddSearchStep, onSelectAndRemainOpen, onSelectTab, onUseFallback, shouldShowCustomTab, visibleTab, } = props;
    useLoadInitialOptions_1.default(onLoadOptions);
    const navItems = dropdownNavItems_1.getNavItems({
        isDisabled: isLoadingMore,
        itemsLabel,
        shouldShowCustomTab,
    });
    const menuProps = getMenuProps({ 'aria-label': `Options for ${itemsLabel}` });
    const onSelectItem = (item) => {
        selectItem(item);
        closeMenu();
    };
    const doOnClear = () => {
        clearSelection();
        onClear();
    };
    const onChooseItem = (item, event) => {
        event.preventDefault();
        event.stopPropagation();
        onSelectTab(item.href);
    };
    const hasCustomChoices = !lodash_1.isEmpty(choiceGroups);
    return (common_utils_1.isolateComponent(FloatingMenu_1.default, { onClickOutside: props.closeMenu },
        common_utils_1.isolateComponent(common_components_1.ClickPropagationBarrier, null,
            common_utils_1.isolateComponent("div", Object.assign({ css: Styles.root }, menuProps, { tabIndex: -1 }),
                common_utils_1.isolateComponent(common_1.Nav, { itemMaxWidth: 135, items: navItems, onChooseItem: onChooseItem, selectedItemHref: visibleTab }),
                common_utils_1.isolateComponent("div", { css: Styles.paneWrapper },
                    dropdownNavItems_1.isOptionTab(visibleTab) && (common_utils_1.isolateComponent(OptionsPane_1.default, { getItemProps: getItemProps, highlightedIndex: highlightedIndex || 0, isLoadingMore: isLoadingMore, items: items, itemsLabel: itemsLabel, loadMoreState: loadMoreState, onClear: doOnClear, onLoadOptions: onLoadOptions, onSelectAndRemainOpen: onSelectAndRemainOpen, onSelectItem: onSelectItem, selectedItem: selectedItem, setHighlightedIndex: setHighlightedIndex })),
                    hasCustomChoices && dropdownNavItems_1.isCustomTab(visibleTab) && (common_utils_1.isolateComponent(CustomMapper_1.default, { canAddSearchStep: canAddSearchStep, choiceGroups: choiceGroups, onAddSearchStep: onAddSearchStep, onSelect: onSelectAndRemainOpen, onUseFallback: onUseFallback })),
                    !hasCustomChoices && dropdownNavItems_1.isCustomTab(visibleTab) && (common_utils_1.isolateComponent(EmptyCustomMapper_1.default, null)))))));
};
DropdownMenu.defaultProps = {
    items: [],
    shouldShowCustomTab: true,
};
exports.default = DropdownMenu;
